// Vendored from the host app (conek-rails `app/frontend/shared/services/notification-service.ts`)
// so the gem has no `shared/*` host-alias coupling. Types stripped, logic identical.
// The gem's Ui::NotificationsMenuComponent + ui--notifications controller depend
// on this exact API surface (getNotifications / markAsRead / markAllAsRead).

import { get, patch, post } from "@rails/request.js"

const NOTIFICATIONS_ENDPOINT = "/api/v1/notifications"

export async function getNotifications(args) {
  const params = new URLSearchParams()
  if (args?.take) params.set("take", String(args.take))
  if (args?.listType) params.set("list_type", args.listType)

  const url = params.toString()
    ? `${NOTIFICATIONS_ENDPOINT}?${params.toString()}`
    : NOTIFICATIONS_ENDPOINT

  const response = await get(url, {
    credentials: "include",
    responseKind: "json",
  })

  if (!response.ok) {
    throw new Error(`Failed to fetch notifications: ${response.statusCode}`)
  }

  return await response.json
}

export async function markAsRead(notificationId) {
  const response = await patch(
    `${NOTIFICATIONS_ENDPOINT}/${notificationId}/mark_as_read`,
    {
      credentials: "include",
      responseKind: "json",
    },
  )

  if (!response.ok) {
    throw new Error(
      `Failed to mark notification as read: ${response.statusCode}`,
    )
  }
}

export async function markAllAsRead() {
  const response = await post(`${NOTIFICATIONS_ENDPOINT}/mark_all_as_read`, {
    credentials: "include",
    responseKind: "json",
  })

  if (!response.ok) {
    throw new Error(`Failed to mark all as read: ${response.statusCode}`)
  }
}
